export const COMMISSIONS_SUMMARY_REQUEST_START: string = 'commissions/summary/REQUEST_START';
export const COMMISSIONS_SUMMARY_REQUEST_FAIL: string = 'commissions/summary/REQUEST_FAIL';
export const COMMISSIONS_SUMMARY_REQUEST_SUCCESS: string = 'commissions/summary/REQUEST_SUCCESS';

export const COMMISSIONS_DETAIL_REQUEST_START: string = 'commissions/detail/REQUEST_START';
export const COMMISSIONS_DETAIL_REQUEST_FAIL: string = 'commissions/detail/REQUEST_FAIL';
export const COMMISSIONS_DETAIL_REQUEST_SUCCESS: string = 'commissions/detail/REQUEST_SUCCESS';

export const COMMISSIONS_DATA_RESET: string = 'commissions/data/RESET';